import React from 'react';
import { useFormikContext } from "formik";
import { FormGroup, Input } from 'reactstrap';
import { FormLabel, FormValue } from './FormLabel';
import { useEdit } from '../../Services/EditContext';

const BooleanInput = ({ id, label, noEdit, style }: { id: string, label: string, noEdit?: boolean, style?: React.CSSProperties }) => {
    const { setFieldValue, values } = useFormikContext<{ [p: string]: boolean }>();
    const [edit] = useEdit();
    const handleChange = (e) => {
        const v = e.target.checked;
        setFieldValue(id, v);
    }

    return edit && !noEdit ? <FormGroup style={{ ...style }} check inline><FormLabel check htmlFor={id} style={{ display: 'block' }}>
        <Input id={id} name={id} type='checkbox' onChange={handleChange} checked={values[id]} />
        {label}
    </FormLabel> </FormGroup> : 
    <FormGroup style={{ ...style }} > 
    <FormLabel>{label}</FormLabel>
    <br />
    <FormValue>{values[id] ? 'Yes' : 'No'}</FormValue>
    </FormGroup>
}

export default BooleanInput;